import Rest from "../../../class/tool/Rest"
import moment from "moment"
moment.locale("fr")

class ArchiveController {
    #_rest = new Rest()
    _callback = null
    _baseURL = "archives"
    _baseURLFile = "/closings/{idClosing}/files";
    _baseURLZip = "/" + this._baseURL + "/{idPeriod}/zip";

    file(type, id) {
        let url;

        switch (type) {
            case "pdf":
            case "xls":
                url = this._baseURLFile.replace("{idClosing}", id) + "?type=" + type;
                break;
            default:
                url = this._baseURLZip.replace("{idPeriod}", id);
                break;
        }

        this.#_rest.sendQuery(
            'GET',
            url,
            {},
            this.handleFile
        )
    }
    handleFile = (response, error, status = 200) => {
        this._callback(response, error, status)
    }

    download(uri, key) {
        this.#_rest._completeUrl = false;
        let pathWay = uri.split('/');
        let url = "";

        for (let i in pathWay) {
            if (pathWay[i].length === 0 || (pathWay[i][0] === "v" && pathWay[i].includes("_")))
                continue;

            url += pathWay[i];
            url += url === "https" ? "//" : "/";
        }

        this.#_rest.sendQuery(
            'GET',
            url.replace("download/", "download?key=") + key,
            {},
            this.handleDownload,
            null,
            "blob"
        )

        this.#_rest._completeUrl = true
    }
    handleDownload = (response, error, status = 200) => {
        this._callback(response, error, status)
    }

    unzip(id, key) {
        this.#_rest.sendQuery(
            'POST',
            '/' + this._baseURL + '/' + id + '/unzip',
            {
                key: key
            },
            this.handleUnzip
        )
    }
    handleUnzip = (response, error, status = 200) => {
        this._callback(response, error, status)
    }
}

export default ArchiveController